import type { PaymentMethod } from '../types/app'

// PAYMENT_METHODS drives every "How did they pay?" / "Mark paid" choice
// across the app (completing an appointment, settling an outstanding one,
// selling a package, Earnings' "Mark paid"), in the order they're offered.
// `card` is a manual record of a payment taken on the therapist's own card
// reader (stored value stays `card`); taking a card payment through Harmovi
// is the separate pay-link flow, not a method here.
export const PAYMENT_METHODS: { method: PaymentMethod; label: string }[] = [
  { method: 'cash', label: 'Cash' },
  { method: 'card', label: 'Card (own reader)' },
  { method: 'bank_transfer', label: 'Bank transfer' },
]

// REPORT_METHODS labels the same methods for reports (Earnings' by-method
// breakdown). There `card` covers pay-link and own-reader payments alike, so
// it is plain "Card"; pickers keep "Card (own reader)".
export const REPORT_METHODS: { method: PaymentMethod; label: string }[] = PAYMENT_METHODS.map((m) =>
  m.method === 'card' ? { ...m, label: 'Card' } : m,
)
